import { render, staticRenderFns } from "./StandartBtnAction.vue?vue&type=template&id=1c7d68f0&scoped=true&"
import script from "./StandartBtnAction.vue?vue&type=script&lang=ts&"
export * from "./StandartBtnAction.vue?vue&type=script&lang=ts&"
import style0 from "./StandartBtnAction.vue?vue&type=style&index=0&id=1c7d68f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d68f0",
  null
  
)

export default component.exports